import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IOrganizationViewDto } from '@/dtos';

export const GET_BENEFICIARY_FORM_URL_QUERY_KEY = 'GET_BENEFICIARY_FORM_URL_QUERY_KEY';

interface OrganizationViewWithCustodian extends IOrganizationViewDto {
  hsa_custodian?: {
    beneficiary_form_url?: string;
  };
}

const useGetBeneficiaryFormUrlQuery = (organizationId?: string, enabled?: boolean) => {
  const { data, isLoading } = useQuery(
    [GET_BENEFICIARY_FORM_URL_QUERY_KEY, organizationId],
    () =>
      api.get<OrganizationViewWithCustodian>(
        API_URL.ORGANIZATIONS_EMPLOYEE_VIEW_BY_ORGANIZATION_ID(organizationId || '')
      ),
    { enabled: Boolean(organizationId && enabled) }
  );

  const beneficiaryFormUrl = useMemo(() => data?.data?.hsa_custodian?.beneficiary_form_url, [data]);

  return {
    beneficiaryFormUrl,
    isLoading,
  };
};

export default useGetBeneficiaryFormUrlQuery;
